export function asidebar(): void {

	var asideSticky = document.getElementById("aside-sticky");
	if (asideSticky == null) return;
	var lasche = asideSticky.querySelector(".aside-slide");
	var btn = asideSticky.querySelector(".btn-aside");
	var sessionValue = sessionStorage.getItem('asideSticky');
	var storageValue = localStorage.getItem('registered');

	var setSessionValue = function (value: any) {
		sessionStorage.setItem('asideSticky', value);
	}
	var changeAside = function (dir: any) {
		if (dir === "in") {
			asideSticky?.classList.add('in');
			setSessionValue("1");
		}
		if (dir === "out") {
			asideSticky?.classList.remove('in');
			setSessionValue("0");
		}
	}
	btn!.addEventListener('click', function (event: any) {
		event.preventDefault();
		setSessionValue("0");
		location.href = event.currentTarget.dataset.target;
	});

	lasche!.addEventListener('click', function (event: any) {
		event.preventDefault();
		var sticky = sessionStorage.getItem('asideSticky');
		if (sticky === "1") {
			changeAside("out");
		}
		else {
			changeAside("in");
		}

	});

	if (storageValue === "1") {
		asideSticky.classList.add('hidden');
	}
	if (sessionValue === "1" || !sessionValue) {
		changeAside("in");
	}

};